import { render, staticRenderFns } from "./vertical-tabs-component.vue?vue&type=template&id=e6024574&scoped=true&"
import script from "./vertical-tabs-component.vue?vue&type=script&lang=ts&"
export * from "./vertical-tabs-component.vue?vue&type=script&lang=ts&"
import style0 from "./vertical-tabs-component.vue?vue&type=style&index=0&id=e6024574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6024574",
  null
  
)

export default component.exports